/**
 * Brazilian Portuguese strings for the `player` namespace — the progress hub page.
 *
 * Keys are in English (repo convention); values are the pt-BR copy shown to users.
 * Skill names are game terms and stay in English, like item names.
 */
export const player = {
  title: 'Perfis de Jogador',
  searchLabel: 'Buscar aventureiro pelo nome',
  searchPlaceholder: 'Ex.: Zezima',
  searchButton: 'Consultar',
  hint: 'O nome exato como aparece no jogo. Cada consulta grava um dia no códice — é daí que a evolução nasce.',
  loading: 'Desenrolando os pergaminhos…',
  loaded: 'Perfil de {{name}} aberto no códice.',
  notFound: 'Nenhum aventureiro com esse nome nos hiscores.',
  error: 'Os hiscores não responderam. A Jagex pode estar instável.',
  retry: 'Tentar de novo',
  updatedAt: 'Consultado em {{when}}',
  stats: {
    totalLevel: 'Nível total',
    combat: 'Combate',
    totalXp: 'XP total',
    rank: 'Rank geral',
  },
  nav: {
    label: 'Seções do perfil',
    profile: 'Perfil',
    skills: 'Habilidades',
    evolution: 'Evolução',
    quests: 'Missões',
    compare: 'Comparar',
  },
  hero: {
    scroll: 'Desça para abrir o códice',
    continue: 'Continuar de onde parou',
    continueStep: '{{title}}',
  },
  skills: {
    label: 'Habilidades',
    maxXp: '200M',
    view: {
      label: 'Modo de exibição das habilidades',
      overview: 'Visão geral',
      progress: 'Progresso',
    },
    progress: {
      caption:
        'XP total, progresso até o próximo nível e ganho de XP por habilidade nas últimas 24 horas, 7 dias e 30 dias',
      skill: 'Habilidade',
      totalXp: 'XP total',
      nextLevel: 'Próximo nível',
      maxLevel: 'Nível máx.',
      needMore:
        'O rastro de {{name}} começou hoje — os números abaixo ainda não têm o que comparar. Cada visita soma mais um dia ao ledger.',
    },
  },
  evolution: {
    unavailable: 'O RuneMetrics não respondeu desta vez — a evolução volta na próxima consulta.',
    title: 'Evolução',
    seal: 'Histórico próprio do RuneLedger · um dia por visita',
    chartLabel: 'Evolução de XP total de {{name}}',
    needMore:
      'O códice acabou de registrar o primeiro dia de {{name}}. Cada visita guarda um dia novo — volte amanhã e a linha começa a existir.',
    gainsLabel: 'Ganhos de XP',
    windowDay: 'Últimas 24 h',
    windowWeek: '7 dias',
    windowMonth: '30 dias',
    sinceDay: 'Desde {{when}}',
    noWindow: '—',
  },
  quests: {
    unavailable: 'O RuneMetrics não respondeu desta vez — o diário volta na próxima consulta.',
    seal: 'Diário de missões · RuneMetrics',
    hidden:
      'O diário de missões de {{name}} está selado — o perfil no RuneMetrics é privado, então só as habilidades aparecem no códice.',
    stats: {
      points: 'Pontos de missão',
      completed: 'Concluídas',
      started: 'Em andamento',
    },
    filterLabel: 'Filtrar missões por estado',
    filters: {
      all: 'Todas',
      COMPLETED: 'Concluídas',
      STARTED: 'Em andamento',
      NOT_STARTED: 'Não iniciadas',
    },
    emptyFilter: 'Nenhuma missão neste estado.',
    listLabel: 'Lista de missões',
    current: 'atual',
    setCurrent: 'Marcar como missão atual',
    unsetCurrent: 'Missão atual ✓',
    status: {
      COMPLETED: 'concluída',
      STARTED: 'em andamento',
      NOT_STARTED: 'não iniciada',
    },
    points_one: '{{count}} pt',
    points_other: '{{count}} pts',
    eligible: 'elegível',
  },
  characters: {
    title: 'Meus personagens',
    listLabel: 'Personagens salvos neste navegador',
    favorite: 'Favoritar {{name}}',
    unfavorite: 'Tirar {{name}} dos favoritos',
    starSolid: '★',
    starHollow: '☆',
  },
  compare: {
    title: 'Comparar com outro aventureiro',
    label: 'Nome do outro aventureiro',
    placeholder: 'Ex.: B0aty',
    button: 'Comparar',
    caption: 'Níveis por habilidade, lado a lado',
    skill: 'Habilidade',
    total: 'Total',
    diff: 'Δ nível',
  },
}
